export const foodDates = ({
  first,
  second,
  numberOfDaysInDelivery = 2,
  text: {
    start,
  } = {
    start: 'питание ',
  },
}) => {
  let text = start
  if (first) {
    if (numberOfDaysInDelivery > 2) {
      text += 'с '
    } else {
      text += 'на '
    }
    text += first
  }
  if (second) {
    if (numberOfDaysInDelivery > 2) {
      text += ' по '
    } else {
      text += ' и '
    }
    text += second
  }
  return text
}
